import React from 'react'
import { displayAuthorName, handleAvatarError } from '../utils'

interface MessageRowProps {
  authorName: string
  isCurrentUser?: boolean
  timestamp: string
  body: string
  avatarUrl?: string
  senderVariant?: 'user' | 'canary'
}

export const MessageRow = React.memo(function MessageRow ({
  authorName,
  isCurrentUser = false,
  timestamp,
  body,
  avatarUrl,
  senderVariant = 'user'
}: MessageRowProps) {
  return (
    <div className='inbox-message-row'>
      {senderVariant === 'canary'
        ? (
          <span className='inbox-message-avatar inbox-message-avatar--canary' aria-hidden='true'>
            <i className='fa-kit fa-pro-canary-logo' />
          </span>
          )
        : (
          <img
            src={avatarUrl}
            alt=''
            className='inbox-message-avatar'
            onError={(event) => handleAvatarError(event.currentTarget)}
          />
          )}

      <div className='inbox-message-content'>
        <div className='inbox-message-header'>
          <span className='inbox-message-author'>{displayAuthorName(authorName, isCurrentUser)}</span>
          <span className='inbox-message-time'>| {timestamp}</span>
        </div>

        <div className='inbox-message-body'>
          {body}
        </div>
      </div>
    </div>
  )
})
